import { useMemo as e } from "react";
const m = ({
  debouncedQuery: t,
  loading: n,
  results: o
}) => {
  const s = e(() => !!o.length, [o]), h = e(() => !!(o.length === 0 && !n && t), [t, n, o.length]);
  return {
    showResults: s,
    showNoResults: h
  };
};
export {
  m as useComboboxFlags
};
